/**
 * Отримує значення з вкладеного об'єкта за заданим шляхом
 * @param {Object} obj - Об'єкт, з якого потрібно отримати значення
 * @param {string} path - Шлях до значення у вигляді рядка "field1.field2.field3"
 * @param {*} defaultValue - Значення за замовчуванням, якщо шлях не існує
 * @returns {*} - Значення з об'єкта або значення за замовчуванням
 */
export const objectValueByPath = (obj, path, defaultValue = undefined) => {
    if (!obj || !path) return defaultValue;
     
    return path.split('.').reduce((acc, key) => {
        if (acc && Object.prototype.hasOwnProperty.call(acc, key)) {
            return acc[key];
        } 
        return undefined;
    }, obj) ?? defaultValue;
};
    
  
/**
 * Встановлює значення у вкладеному об'єкті за заданим шляхом
 * @param {Object} obj - Вхідний об'єкт, який не буде змінений
 * @param {string} path - Шлях до значення у вигляді рядка "field1.field2.field3"
 * @param {*} value - Нове значення, яке потрібно встановити
 * @returns {Object} - Нова структура об'єкта зі зміненим значенням
 */
export const setObjectValueByPath = (obj, path, value) => {
    if (!obj || typeof path !== 'string') return obj;

    // Розділяємо шлях на ключі
    const keys = path.split('.');

    // Копіюємо оригінальний об'єкт
    const result = { ...obj };

    // Вказівник на поточний рівень копії об'єкта
    let current = result;

    keys.forEach((key, index) => {
        if (index === keys.length - 1) {
            // Якщо це останній ключ, встановлюємо значення
            current[key] = value;
        } else {
            // Якщо ключ ще не існує, створюємо порожній об'єкт
            current[key] = current[key] ? { ...current[key] } : {};
        }

        // Переходимо до наступного рівня
        current = current[key];
    });

    return result;
};
